import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=9a0178fa&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a0178fa')) {
      api.createRecord('9a0178fa', component.options)
    } else {
      api.reload('9a0178fa', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=9a0178fa&", function () {
      api.rerender('9a0178fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eKj0yD3V9saX/JS/imageCarousel.vue"
export default component.exports